module.exports = __webpack_public_path__ + "media/fuwocheng.2ee192b8.mp4";